(function ($) {
  var __ = {
    body: $('body'),
    window: $(window),
    // Scene Controller
    controller: window._animations.base.controller,
    global: window._animations.base,
    ajax: {},
    fetch: new ScrollMagic.Scene(),
    splitText: {},
    wasLarge: window.outerWidth > 975,

    banner: function () {

      var timeline = new TimelineMax();

      if (__.global.screen === "large") {

        __.splitText.banner_title =  __.global.splitText($( '.pg-internal-projects--banner-title' ));
        __.splitText.banner_text =  __.global.splitText($( '.pg-internal-projects--banner-text' ));

        timeline
          .add(TweenMax.from('.pg-header--logo', 0.4, __.global.animations.fade.down), '+=1')
          .add(TweenMax.from('.pg-navigation', 0.4, __.global.animations.slide.right), '+=1')
          .add(TweenMax.from('.pg-toggle--animation', 0.2, __.global.animations.fade.up))
          .add(TweenMax.from('.pg-internal-projects--banner-image-container', 0.4, __.global.animations.fade.right))
          .add(TweenMax.from('.pg-header--social', 0.4, __.global.animations.fade.left))
          .add(TweenMax.from('.pg-internal-projects--banner-content', 0.4, __.global.animations.fade.right), '-=0.4' );
        __.global.staggerDisplay( __.splitText.banner_title, timeline);
        __.global.staggerDisplay( __.splitText.banner_text, timeline);

        timeline.call(function () {
          __.grid();
          __.global.completeLoadInAnimation();
          __.splitText.banner_title.revert();
          __.splitText.banner_text.revert();

        });

      } else {
        timeline
        .add(TweenMax.from('.pg-header--logo', 0.4, __.global.animations.fade.down), '+=1')
        .add(TweenMax.from('.pg-navigation', 0.4, __.global.animations.fade.down), '+=1')
        .add(TweenMax.from('.pg-toggle--animation', 0.2, __.global.animations.fade.down))
        .add(TweenMax.from('.pg-internal-projects--banner-content-container', 0.4, __.global.animations.fade.right))
        .add(TweenMax.from('.pg-internal-projects--banner-content', 0.4, __.global.animations.fade.up))
        .call(function() {
            __.grid();
            __.global.completeLoadInAnimation();
        });

      }
      timeline.play();
    },

    grid: function(){
      $('.pg-work--posts').addClass('pg-work--display');
    },

    carousel: function(){

      var timeline = new TimelineMax();

      __.splitText.carousel_text =  __.global.splitText($( '.pg-internal-projects--carousel-text' ));

      timeline.add(TweenMax.from('.pg-internal-projects--carousel-line', 0.4,  { width: 0 }) );
      timeline.add(TweenMax.from('.pg-internal-projects--carousel-title', 0.4,   __.global.animations.fade.up), '+=0.2');
      __.global.staggerDisplay( __.splitText.carousel_text, timeline);
      timeline.add(TweenMax.from('.pg-rotator', 0.2, __.global.animations.fade.up, 0));


      timeline.call(function() {
        __.splitText.carousel_text.revert();
      });

      new ScrollMagic.Scene({
          duration: 0,
          offset: 150,
          triggerHook: 1,
          reverse: false,
          triggerElement: '.pg-internal-projects--carousel-title-container'
      })
      .setTween( timeline )
      .addTo(__.controller);
    },

    loadAnimations: function() {
      __.banner();
      __.carousel();
      window._animations.base.footerAnimations();

    },

    addHandlers: function(){



      function singleWorkClickHandlerForMobile() {
        $(this).toggleClass('active');
      }

      if (__.global.screen === "large") {
        $('.pg-internal-work-single').has('video').on('mouseover', function(event) {
          $(this).find('video').get(0).pause();
        }).on('mouseout', function(event) {
          $(this).find('video').get(0).play();
        });

      } else {
        $('.pg-internal-work-single').on('click', singleWorkClickHandlerForMobile);
        $('.pg-internal-work-single').has('video').toggle(
          function(event) {
            $(this).find('video').get(0).pause();
          },
          function(event) {
            $(this).find('video').get(0).play();
          }
        );
      }

      $(window).on('resize', function(){
        var isLarge = window.outerWidth > 975;
        if(__.wasLarge !== isLarge) {
          if(isLarge) {
            $('.pg-internal-work-single').off('click', singleWorkClickHandlerForMobile);
          } else {
            $('.pg-internal-work-single').on('click', singleWorkClickHandlerForMobile);
          }
          __.wasLarge = isLarge;
        }
      });
    },

    // Function to call to setup functionality
    setup: function () {
      __.loadAnimations();
      __.addHandlers();
    }
  };
  // Attach Toolbox to window //
  if (typeof window._animations === "undefined") {
    window._animations = {};
  }
  window._animations.internalProjects = __;
})(jQuery); // Fully reference jQuery after this point.
